<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img :src="getProfilePicture()" class="c-avatar-img" />
        </div>
      </CHeaderNavLink>
    </template>
    <!-- <CDropdownItem>
      <CIcon name="cil-envelope-open" />Notification
      <CBadge color="success" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <CDropdownItem @click="funcLinkTo('/')">
      <CIcon name="cil-user" />Homepage
    </CDropdownItem>
    <CDropdownItem @click="funcLinkTo('/logout')">
      <CIcon name="cil-lock-locked" />Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheAdminHeaderDropdown",
  data() {
    return {
      itemsCount: 42,
      imgProfile: "",
    };
  },
  computed: {
    ...mapGetters({
      getUserinfo: "necessary/getUserinfo",
    }),
  },
  watch: {
    getUserinfo: function (val) {
      this.imgProfile = val.imageProfile;
    },
  },
  created() {
    if (this.$store.getters["necessary/getUserinfo"].length !== 0) {
      this.imgProfile = this.$store.getters[
        "necessary/getUserinfo"
      ].imageProfile;
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    funcLinkTo(path) {
      if (path == "/logout") {
        this.$store.commit("language/setChangingSidebar", false);
        this.$store.dispatch("auth/logout");
      } else {
        this.$store.commit("language/setChangingSidebar", false);
        this.$router.push(path);
      }
    },
    getProfilePicture() {
      return this.imgProfile;
    },
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
.c-avatar-img {
    width: 100%;
    height: 100%;
    border-radius: 50em;
}
.c-header-nav .dropdown-item:hover {
    background-color: #E6E6E6 !important;
}
</style>